import { singleton, container } from 'tsyringe';
import { AuthService, FileService, ImageService } from 'zr-arch';
import { 提示Service } from './提示Service';
import ApiService from './ApiService';

@singleton()
export default class Services {
    授权: AuthService = container.resolve(AuthService);
    提示: 提示Service = container.resolve(提示Service);
    api: ApiService = container.resolve(ApiService);
    图片: ImageService = container.resolve(ImageService);
    文件: FileService = container.resolve(FileService);
}
